import { combineReducers } from "redux";

import contactus from "../features/admin/contactuss/contactus/Slice";
import enquiryform from "../features/admin/contactuss/enquiry_form/Slice";
import productenquiry from "../features/admin/contactuss/product_enquiry/Slice";

import common from "../features/admin/common/Slice";

const contactuss = combineReducers({
    contactus,
    common,
    enquiryform,
    productenquiry
});

export default contactuss;